import { TrackingCategoryItem } from '~shared/modules/shopping-cart-global/models';

export const getCategoryIdHelper = (category: string | TrackingCategoryItem) => {
  if (typeof category === 'object') {
    return category.id;
  }

  return '';
}
